import { AuthContext } from '../../contexts/Auth/AuthContext';
import Link from 'next/link';
import React, { useState, useEffect, useContext } from 'react';
import { AiOutlineClose, AiOutlineFacebook, AiOutlineInstagram, AiOutlineMail, AiOutlineMenu, AiOutlineWhatsApp } from 'react-icons/ai';
import { RedeSocial } from '../RedeSocial';
import { Button } from '../Button';
import { IoHelp } from 'react-icons/io5';
import { BsCurrencyDollar } from 'react-icons/bs';
import Image from 'next/image';
import logoHorizontalBranca from '../../public/logo-horizontal-azul.png'
import logo from '../../public/logo-azul.png'
import { FiUserPlus } from 'react-icons/fi';
import { CiLogin } from 'react-icons/ci';

export const Navbar = () => {
    const [nav, setNav] = useState(false);
    const [linkColor, setLinkColor] = useState('#FFFF');
    const handleNav = () => {
        setNav(!nav);
    };

    return (
        <header className='bg-white/80 w-full border-b flex items-center justify-center !backdrop-blur-sm border-gray-200 fixed h-20 z-50 top-0 left-0 right-0'>
            <nav className={`flex w-full h-full items-center justify-center`}>
                <div className='flex items-center justify-between w-full h-full max-w-6xl p-2'>
                    <div className='flex items-center gap-3'>
                        <Link href='/'>
                            <div className='w-10 cursor-pointer'>
                                <Image objectFit="fill"
                                    alt='logo'
                                    src={logo}
                                    className=''
                                    priority
                                />
                            </div>
                        </Link>
                        {/* Hamburger Icon */}
                        <div style={{ color: `${linkColor}` }}
                            onClick={handleNav}
                            className='lg:hidden'>
                            <AiOutlineMenu size={20} color='black'
                            />
                        </div>
                    </div>
                    <div className='items-center justify-center hidden md:flex md:gap-14'>
                        <Link href={'/'}><a className='p-2 text-black hover:bg-gray-200 rounded-xl'>Inicio</a></Link>
                        <Link href={'/preco'}><a className='p-2 text-black hover:bg-gray-200 rounded-xl'>Preços</a></Link>
                        <Link href={'/ajuda'}><a className='p-2 text-black hover:bg-gray-200 rounded-xl'>Ajuda</a></Link>
                    </div>
                    <div className='hidden gap-2 md:flex'>
                        <Link href={'/admin'}>
                            <a className='decoration-transparent'>
                                <Button color='bg-white/10' textColor='text-gray-800 font-bold' className="nav-link rounded-xl">Entrar</Button>
                            </a>
                        </Link>
                        <Link href={'/cadastrar'}>
                            <a className='decoration-transparent'>
                                <Button color='bg-rifaweb-primario' textColor='text-white'>Criar conta</Button>
                            </a>
                        </Link>
                    </div>

                    {/* MOBILE */}
                    <div className='flex md:hidden'>
                        <Link href={'/admin'}>
                            <a className='decoration-transparent'>
                                <Button color='bg-transparent' textColor='text-gray-800 font-bold' className="mx-2 nav-link rounded-xl">Entrar</Button>
                            </a>
                        </Link>
                        <Link href={'/cadastrar'}>
                            <a className='decoration-transparent'>
                                <Button color='bg-rifaweb-primario' textColor='text-white font-bold'>Criar conta</Button>
                            </a>
                        </Link>
                    </div>
                </div>

                {/* Mobile Menu */}
                <div className={nav ? 'md:hidden fixed left-0 top-0 w-full h-screen bg-black/70' : ''}>
                    {/* Side Drawer Menu */}
                    <div className={nav ? 'fixed left-0 top-0 w-[90%] sm:w-[60%] md:w-[45%] h-screen bg-white ease-in duration-200'
                        : 'fixed left-[-100%] top-0 ease-in duration-200'}>
                        <div className='flex flex-col'>
                            <div className='flex flex-col gap-1 px-2'>
                                <div className='flex items-center justify-between mt-4'>
                                    <Link href={'/admin'}>
                                        <a className="flex items-center gap-2 mx-2 text-base text-black decoration-transparent">
                                            <CiLogin className='p-1 rounded-md bg-rifaweb-secundario text-rifaweb-primario' size={30} />
                                            Entrar
                                        </a>
                                    </Link>
                                    <AiOutlineClose className='pr-2 text-black' onClick={handleNav} size={30} />
                                </div>
                                <hr className='text-gray-800' />
                                <Link href={'/cadastrar'}>
                                    <a onClick={() => setNav(false)} className="flex items-center gap-2 mx-2 text-base text-black decoration-transparent">
                                        <FiUserPlus className='p-1 rounded-md bg-rifaweb-secundario text-rifaweb-primario' size={30} />
                                        Criar conta
                                    </a>
                                </Link>
                                <hr className='text-gray-800' />
                                <Link href={'/preco'}>
                                    <a onClick={() => setNav(false)} className='flex items-center gap-2 mx-2 text-base text-black decoration-transparent'>
                                        <BsCurrencyDollar className='p-1 text-gray-800 bg-white rounded-md' size={30} /> Preço
                                    </a>
                                </Link>
                                <hr className='text-gray-800' />
                                <Link href={'/ajuda'}>
                                    <a onClick={() => setNav(false)} className='flex items-center gap-2 mx-2 text-base text-black decoration-transparent'>
                                        <IoHelp className='p-1 text-gray-800 bg-white rounded-md' size={30} /> Ajuda
                                    </a>
                                </Link>
                                <hr className='text-gray-800' />
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </header>
    );
};